import { ProjectElementNode } from '@deltek/specification-client/core/Models/productListingDetail'
import { ProjectUniformatClassification } from '@deltek/specification-client/core/Models/projectUniformatClassification'
import { UniformatClassification } from '@deltek/specification-client/core/Models/uniformatClassification'
import { UniformatClassificationProperty } from '@deltek/specification-client/core/Models/uniformatClassificationProperty'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Button from '@material-ui/core/Button'
import Collapse from '@material-ui/core/Collapse'
import { makeStyles, Theme } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import DragIndicatorIcon from '@material-ui/icons/DragIndicator'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import clsx from 'clsx'
import React from 'react'
import { KeyValuePair } from '..'
import { getAssemblyLevel } from './ElementsPanel/ElementsPanel'

const reviewAssemblyComponentStyles = makeStyles((theme: Theme) => ({
    accordionContainer: {
        overflowY: 'auto',
        height: 'calc(100% - 60px)',
        paddingRight: theme.spacing(1),
        '&::-webkit-scrollbar': {
            width: 6,
            height: 20,
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#464646',
            borderRadius: 100,
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'none',
        },
    },
    paperContainer: {
        border: '1px solid #DADADA',
        marginBottom: theme.spacing(2),
        boxShadow: 'none',
        transition: 'none',
        borderRadius: pxToRem(4),
        '&:hover': {
            border: '1px solid #A78966',
            boxSizing: 'border-box',
            boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
            backgroundClip: 'padding-box',
            '& .accordionIcons': {
                display: 'flex',
            },
        },
    },
    paperCollapsed: {
        height: pxToRem(46),
    },
    accordion: {
        boxShadow: 'none',
        marginBottom: theme.spacing(1.25),
        backgroundColor: 'transparent',
    },
    accordionCollapsed: {
        height: pxToRem(46),
    },
    accordionGridItem: {
        flexGrow: 1,
        overflow: 'hidden',
        width: 'calc(100% - 26px)',
        marginTop: -theme.spacing(0.125),
        marginRight: -theme.spacing(0.125),
    },
    assemblyName: {
        color: theme.palette.secondary.main,
        fontSize: pxToRem(18),
        paddingLeft: theme.spacing(2),
        margin: 'auto 0',
    },
    expansionIcon: {
        fill: theme.palette.secondary.main,
        paddingLeft: theme.spacing(1),
        marginTop: theme.spacing(0.25),
    },
    assemblyTextField: {
        '& .MuiInputBase-formControl': {
            minHeight: 35,
            fontSize: pxToRem(10),
            maxWidth: 450,
            minWidth: 100,
            padding: '5px 10px',
        },
        '& .MuiInputBase-root': {
            lineHeight: pxToRem(20),
        },
        width: '100%',
        paddingLeft: theme.spacing(7),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    assemblySummary: {
        '& .accordionIcons': {
            background: theme.palette.secondary.main,
            color: theme.palette.common.white,
            display: 'none',
            alignItems: 'center',
            borderTopRightRadius: pxToRem(4),
        },
    },
    assemblySummaryCollapsed: {
        '& .accordionIcons': {
            borderBottomRightRadius: pxToRem(4),
        },
    },
    inputText: {
        fontSize: pxToRem(14),
    },
    expandCollapseButton: {
        border: '1px solid #c9c9c9',
        borderRadius: theme.spacing(2.5),
        color: '#04325B',
        lineHeight: 1.43,
        padding: '5px 10px',
    },
    buttonLabel: {
        lineHeight: '16px',
    },
    expandCollapseContainer: {
        justifyContent: 'flex-end',
        display: 'flex',
        '& button:first-child': {
            marginRight: theme.spacing(1),
        },
        marginBottom: theme.spacing(2),
        marginRight: theme.spacing(1),
        paddingTop: theme.spacing(2),
    },
    dragIcon: {
        color: theme.palette.common.white,
        visibility: 'hidden',
        marginTop: theme.spacing(5),
    },
    dragIconCollapsed: {
        marginTop: theme.spacing(1),
    },
    dragIconGridItem: {
        backgroundColor: '#A78966',
        width: pxToRem(26),
        visibility: 'hidden',
        borderTopLeftRadius: pxToRem(4),
        borderBottomLeftRadius: pxToRem(4),
        margin: '-1px 0px -1px -1px',
    },
    dragIconGridItemCollapsed: {
        height: pxToRem(46),
    },
    visibileItems: {
        visibility: 'visible',
    },
    summaryTextContainer: {
        display: 'flex',
        flexGrow: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    summaryTextContainerHovered: {
        borderBottom: '1px solid #DADADA',
    },
    accordionIcons: {
        background: theme.palette.secondary.main,
        color: theme.palette.common.white,
        display: 'none',
        alignItems: 'center',
    },
    icons: {
        fontSize: pxToRem(23),
        margin: theme.spacing(0, 1),
        cursor: 'pointer',
    },
    iconsInactive: {
        fontSize: pxToRem(23),
        margin: theme.spacing(0, 1),
    },
    addIcon: {
        border: '1.5px dashed #fff',
        fontSize: pxToRem(25),
        margin: theme.spacing(0, 1),
        borderRadius: '15%',
        color: theme.palette.common.white,
        cursor: 'pointer',
    },
    addIconInactive: {
        border: '1.5px dashed #bea78d',
        color: '#bea78d',
        fontSize: pxToRem(25),
        margin: theme.spacing(0, 1),
        borderRadius: '15%',
    },
    horizontalIcon: {
        fontSize: pxToRem(25),
        margin: theme.spacing(0, 1),
        borderRadius: '50%',
        border: '1.5px solid #fff',
        color: theme.palette.common.white,
        cursor: 'pointer',
    },
    horizontalIconInactive: {
        border: '1.5px dashed #bea78d',
        color: '#bea78d',
        margin: theme.spacing(0, 1),
        borderRadius: '50%',
    },
    container: {
        flexWrap: 'unset',
    },
    collapsiblePanel: {
        transition: 'none',
    },
    emptyAssemblyText: {
        color: theme.palette.grey[500],
        fontSize: pxToRem(14),
        textAlign: 'center',
    },
    emptyTextContainer: {
        margin: 'auto',
        marginTop: theme.spacing(2),
        paddingRight: theme.spacing(1),
        maxWidth: pxToRem(550),
    },
}))

export interface ReviewAssemblyComponentInterface {
    selectedElementData:
        | Partial<ProjectUniformatClassification>
        | Partial<UniformatClassification>
        | undefined
    projectElementNode: ProjectElementNode
    setPropertyValue?: (val: Record<string, string>) => void
    propertyValue: Record<string, string>
    handleUpdatePUCPropertyValue: (elementId: string) => void
    setCurrentValue?: (inputVal: KeyValuePair) => void
    contentTeamFromStudioPage?: boolean
}
const ReviewAssemblyComponent: React.FC<ReviewAssemblyComponentInterface> = ({
    selectedElementData,
    projectElementNode,
    setPropertyValue,
    propertyValue,
    handleUpdatePUCPropertyValue,
    contentTeamFromStudioPage,
}) => {
    const classes = reviewAssemblyComponentStyles()
    const [isExpanded, setIsExpanded] = React.useState<Record<string, boolean>>(
        {}
    )
    const [itemOnHover, setItemOnHover] = React.useState<string | null>(null)
    const [hasChanges, setHasChanges] = React.useState<boolean>(false)

    const isL3Assembly = React.useMemo(
        () => getAssemblyLevel(projectElementNode.text.split('|')[0]) === 1,
        [projectElementNode]
    )

    const handleExpansion = (elementDataId: string) => (
        _: React.MouseEvent
    ) => {
        setIsExpanded({
            ...isExpanded,
            [elementDataId]: !isExpanded[elementDataId],
        })
    }

    const updateChanges = (elementDataId: string) => (
        _: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        if (hasChanges) {
            handleUpdatePUCPropertyValue(elementDataId)
            setHasChanges(false)
        }
    }

    React.useEffect(() => {
        if (selectedElementData?.uniformatClassificationProperties) {
            const currentIsExpanded: Record<string, boolean> = {}
            const currentPropertyValue: Record<string, string> = {}
            selectedElementData.uniformatClassificationProperties.forEach(
                (elementData: Partial<UniformatClassificationProperty>) => {
                    currentIsExpanded[elementData.id ?? ''] = true
                    currentPropertyValue[elementData.id ?? ''] =
                        elementData.value ?? ''
                }
            )
            setIsExpanded(currentIsExpanded)
            setPropertyValue?.(currentPropertyValue)
        }
    }, [selectedElementData, setIsExpanded, setPropertyValue])

    const handleChange = (elementDataId: string) => (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const currentValue = event.currentTarget.value
        if (!currentValue.includes('\n')) {
            setHasChanges(true)
            setPropertyValue?.({
                ...propertyValue,
                [elementDataId]: currentValue,
            })
        }
    }

    const handleExpandAll = () => {
        const currentIsExpanded = { ...isExpanded }
        for (let key in currentIsExpanded) {
            currentIsExpanded[key] = true
        }
        setIsExpanded(currentIsExpanded)
    }

    const handleCollapseAll = () => {
        const currentIsExpanded = { ...isExpanded }
        for (let key in currentIsExpanded) {
            currentIsExpanded[key] = false
        }
        setIsExpanded(currentIsExpanded)
    }

    return (
        <>
            {selectedElementData?.uniformatClassificationProperties?.length ? (
                <div className={classes.expandCollapseContainer}>
                    <Button
                        className={clsx(
                            classes.expandCollapseButton,
                            'expand-all-button'
                        )}
                        variant="outlined"
                        endIcon={<KeyboardArrowDownIcon />}
                        onClick={handleExpandAll}
                        classes={{
                            label: classes.buttonLabel,
                        }}
                    >
                        Expand All
                    </Button>
                    <Button
                        className={clsx(
                            classes.expandCollapseButton,
                            'collapse-all-button'
                        )}
                        variant="outlined"
                        endIcon={<KeyboardArrowUpIcon />}
                        onClick={handleCollapseAll}
                        classes={{
                            label: classes.buttonLabel,
                        }}
                    >
                        Collapse All
                    </Button>
                </div>
            ) : null}
            <div className={classes.accordionContainer}>
                {selectedElementData?.uniformatClassificationProperties
                    ?.length ? (
                    selectedElementData?.uniformatClassificationProperties?.map(
                        (
                            elementData: Partial<
                                UniformatClassificationProperty
                            >
                        ) => {
                            return (
                                <GridContainer
                                    key={elementData.id}
                                    className={clsx(
                                        !itemOnHover && classes.container,
                                        classes.paperContainer,
                                        !Boolean(
                                            isExpanded[elementData?.id ?? '']
                                        ) && classes.paperCollapsed
                                    )}
                                    onMouseOver={() =>
                                        setItemOnHover(elementData.id as string)
                                    }
                                >
                                    <GridItem
                                        className={clsx(
                                            classes.dragIconGridItem,
                                            itemOnHover === elementData.id &&
                                                classes.visibileItems,
                                            !Boolean(
                                                isExpanded[
                                                    elementData?.id ?? ''
                                                ]
                                            ) &&
                                                classes.dragIconGridItemCollapsed
                                        )}
                                    >
                                        <DragIndicatorIcon
                                            className={clsx(
                                                classes.dragIcon,
                                                !Boolean(
                                                    isExpanded[
                                                        elementData?.id ?? ''
                                                    ]
                                                ) && classes.dragIconCollapsed
                                            )}
                                        />
                                    </GridItem>
                                    <GridItem
                                        className={classes.accordionGridItem}
                                    >
                                        <GridContainer
                                            id="accordionId"
                                            data-testid="accordionTestId"
                                            key={elementData.id}
                                            className={clsx(
                                                classes.accordion,
                                                !Boolean(
                                                    isExpanded[
                                                        elementData?.id ?? ''
                                                    ]
                                                ) && classes.accordionCollapsed,
                                                !Boolean(
                                                    isExpanded[
                                                        elementData?.id ?? ''
                                                    ]
                                                ) &&
                                                    classes.assemblySummaryCollapsed,
                                                classes.assemblySummary,
                                                classes.container
                                            )}
                                        >
                                            <div
                                                className={clsx(
                                                    classes.summaryTextContainer,
                                                    itemOnHover ===
                                                        elementData.id &&
                                                        classes.summaryTextContainerHovered
                                                )}
                                                data-testid="accordionSummary"
                                            >
                                                {Boolean(
                                                    isExpanded[
                                                        elementData?.id ?? ''
                                                    ]
                                                ) ? (
                                                    <ExpandMoreIcon
                                                        onClick={handleExpansion(
                                                            elementData?.id ??
                                                                ''
                                                        )}
                                                        fontSize={'large'}
                                                        className={
                                                            classes.expansionIcon
                                                        }
                                                        data-testid="expandIcon"
                                                    />
                                                ) : (
                                                    <ChevronRightIcon
                                                        onClick={handleExpansion(
                                                            elementData?.id ??
                                                                ''
                                                        )}
                                                        fontSize={'large'}
                                                        className={
                                                            classes.expansionIcon
                                                        }
                                                        data-testid="chevronRightIcon"
                                                    />
                                                )}
                                                <Typography
                                                    noWrap
                                                    component="span"
                                                    className={
                                                        classes.assemblyName
                                                    }
                                                >
                                                    {elementData.name}
                                                </Typography>
                                            </div>
                                        </GridContainer>
                                        <Collapse
                                            in={Boolean(
                                                isExpanded[
                                                    elementData?.id ?? ''
                                                ]
                                            )}
                                            className={classes.collapsiblePanel}
                                        >
                                            <TextField
                                                variant="outlined"
                                                multiline
                                                placeholder={elementData.hint}
                                                className={clsx(
                                                    classes.assemblyTextField,
                                                    'elementPropertiesTextfield'
                                                )}
                                                name="ElementPropertiesInput"
                                                value={
                                                    propertyValue[
                                                        elementData.id ?? ''
                                                    ] ?? ''
                                                }
                                                onChange={handleChange(
                                                    elementData.id ?? ''
                                                )}
                                                inputProps={{
                                                    className:
                                                        classes.inputText,
                                                    'aria-autocomplete': 'none',
                                                    autoComplete: 'chrome-off',
                                                    maxLength: 500,
                                                }}
                                                disabled={
                                                    !projectElementNode.elementId ||
                                                    contentTeamFromStudioPage
                                                }
                                                data-testid="assembliesTextField"
                                                onBlur={updateChanges(
                                                    elementData.id ?? ''
                                                )}
                                            ></TextField>
                                        </Collapse>
                                    </GridItem>
                                </GridContainer>
                            )
                        }
                    )
                ) : (
                    <div className={classes.emptyTextContainer}>
                        <Typography
                            component="span"
                            className={classes.emptyAssemblyText}
                            display="block"
                        >
                            {isL3Assembly
                                ? 'No properties associated found'
                                : 'Select the Parent of this Subassembly in order to view Performance Requirements. Assembly parents are designated with 5 characters (ex.A1010)'}
                        </Typography>
                    </div>
                )}
            </div>
        </>
    )
}

export default ReviewAssemblyComponent
